export default __webpack_public_path__ + "static/takeTime-3ed327b69948a984335174cb34d131d3.jpg";